import { Box, Skeleton, Stack } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { VendorOpportunity } from 'modules/vendorOpportunity';
import { InsuranceStepper } from './insuranceStepper';
import { CoverageStatus } from './CoverageStatus';
import { InsuranceHeader } from './InsuranceHeader';
import { InsuranceAccordion } from './insuranceAccordion';
import { useFetchInsuranceData } from '../hooks/useFetchInsuranceData';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { insuranceActions } from '../model';
import { FormProvider, useForm } from 'react-hook-form';
import { FinanceProgramFormValues } from 'modules/desking/types';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

interface Props {
  creditApp: any;
  vo: VendorOpportunity;
}

export const InsuranceTab = ({ vo, creditApp }: Props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const methods = useForm<FinanceProgramFormValues>({});

  const { isFetching } = useFetchInsuranceData(vo, creditApp);

  useEffect(
    () => () => {
      dispatch(insuranceActions.clearState());
    },
    [dispatch]
  );

  return (
    <Box className={classes.root}>
      {!isFetching ? (
        <Stack gap="1rem">
          <InsuranceStepper />
          <DndProvider backend={HTML5Backend}>
            <FormProvider {...methods}>
              <InsuranceHeader />
            </FormProvider>
          </DndProvider>
          <CoverageStatus />
          <InsuranceAccordion />
        </Stack>
      ) : (
        <Skeleton variant="rectangular" height="300px" width="100%" />
      )}
    </Box>
  );
};

const useStyles = makeStyles({
  root: {
    backgroundColor: 'white',
    padding: '24px',
    color: '#000000de',
  },
});
